import { createSelector } from 'reselect';
import { selectGameTurn, selectIsActivePlayer, selectOptions } from '../ActiveGame/selectors';
import { optionReason } from '../ActiveGame/options';

const selectDomain = (state) => state.deck;

export const selectDrawing = createSelector(
  [selectDomain], (state) => state.get('drawing'),
);
/**
 * The draw that starts `userId`'s turn: null when none is owed (not their turn, or they drew), otherwise why it can't
 * happen yet (`reason`, from the server: waiting on the opponent's new active Pokémon, say) and whether it's under
 * way. The Draw a card button and dragging the deck to the hand both go by this.
 */
export const selectDrawOwed = createSelector(
  [selectIsActivePlayer, selectGameTurn, selectOptions, selectDrawing],
  (isActivePlayer, gameTurn, options, drawing) => (!isActivePlayer || !gameTurn || gameTurn.get('drew') ? null : {
    reason: optionReason(options && options.get('draw')),
    drawing,
  }),
);
